import { useCallback, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

import * as Constants from "../../model/constants";

type Props = {
	cardId?: string;
	guestName: string;
	memo: string;
	color: string;
	// パネルの高さ
	height: number;
	// 基準値からの位置
	top: number;
	// 基準値からの位置
	left: number;
	// サブオプション名
	subOptionName: string | null;
	// 合計人数
	guestTotalNumberText: string | null;
	// サブオプション名を表示するかどうか
	showSubOptionName: boolean;
	// 合計人数を表示するかどうか
	showGuestTotalNumber: boolean;
	// パネルのクリックイベント
	onClickPanel: (cardId?: string) => void;
};

export const TimelinePanel = ({ cardId, guestName, memo, color, height, top, left, subOptionName, guestTotalNumberText, showSubOptionName, showGuestTotalNumber, onClickPanel }: Props) => {
	/**
	 * パネルのクリックイベント
	 */
	const handleClickPanel = useCallback(() => {
		onClickPanel(cardId);
	}, [ onClickPanel, cardId ]);

	/**
	 * サブオプション名を表示するかどうか
	 */
	const shouldShowSubOptionName = useMemo(
		() => showSubOptionName && Boolean(subOptionName),
		[ showSubOptionName, subOptionName ],
	);

	/**
	 * 合計人数を表示するかどうか
	 */
	const shouldShowGuestTotalNumber = useMemo(
		() => showGuestTotalNumber && Boolean(guestTotalNumberText),
		[ showGuestTotalNumber, guestTotalNumberText ],
	);

	return (
		<button
			type="button"
			className={cn(
				"absolute", //
				"flex cursor-pointer items-start overflow-hidden rounded border border-white p-2 text-left text-xs",
				"duration-300 ease-out hover:z-[calc(infinity)] hover:scale-[1.05] hover:border-white",
			)}
			onClick={handleClickPanel}
			style={{
				background: color,
				top: `${top + Constants.PanelTopOffset}px`,
				left: `${left + Constants.PanelLeftBaseOffset}px`,
				minWidth: `${Constants.PanelWidth}px`,
				maxWidth: `${Constants.PanelWidth}px`,
				minHeight: `${height}px`,
				maxHeight: `${height}px`,
			}}
		>
			<div className="space-y-1.5">
				<p className="line-clamp-1 font-semibold">{guestName}</p>
				{shouldShowSubOptionName && (
					<p className="text-xs text-gray-500">
						{subOptionName}
					</p>
				)}
				{shouldShowGuestTotalNumber && (
					<p className="line-clamp-1 text-xs text-gray-500">
						{guestTotalNumberText}
					</p>
				)}
				<p className="line-clamp-[8]">{memo}</p>
			</div>
		</button>
	);
};
